import React from 'react'

import { faDownload } from '@fortawesome/pro-light-svg-icons'

import { digObject } from '@domain-group/javascript-utils'
import { SidebarModalListItem } from '@domain-group/suit-theme'

import useAssetLibrary from '@hooks/useAssetLibrary'
import useAttachment from '@hooks/useAttachment'

import { confirmDelete } from '@functions/entity'

import type { AttachmentModel } from '@models/attachment'

interface AttachmentListItemProps {
  attachment: AttachmentModel,
}
const AttachmentListItem = (props: AttachmentListItemProps) => {
  const { attachment, attachment: { data } } = props

  const createdAtDate = digObject(attachment, 'dates.created.date', '')

  const attachmentPayload = useAttachment(attachment)
  const {
    callbacks: {
      deleteAttachment: deleteFn,
      downloadAttachment,
      createOrEditAttachment,
    },
  } = attachmentPayload

  const confirmDeletePayload = {
    callbacks: {
      deleteFn,
    },
    strings: {
      confirmString: 'Are you sure?',
      entityName: 'Attachment',
    },
  }

  const { editable } = useAssetLibrary({ id: attachment.attachable_id })

  return (
    // @ts-expect-error TS2339
    <SidebarModalListItem secondaryText={`Uploaded ${createdAtDate}`} title={data?.title}>
      {/*
       // @ts-expect-error TS2339 */}
      <SidebarModalListItem.Actions>
        {/*
         // @ts-expect-error TS2339 */}
        <SidebarModalListItem.Icon
          marginRight="medium"
          // @ts-expect-error TS2345
          onClick={(e: React.ChangeEvent<HTMLInputElement>) => downloadAttachment(e)}
          icon={faDownload}
        />

        {/*
         // @ts-expect-error TS2339 */}
        <SidebarModalListItem.Icon
          marginRight={editable ? 'medium' : 0}
          onClick={() => createOrEditAttachment()}
          type="edit"
        />

        {editable && (
          // @ts-expect-error TS2339
          <SidebarModalListItem.Icon
            onClick={() => confirmDelete(confirmDeletePayload)}
            type="delete"
          />
        )}
        {/*
       // @ts-expect-error TS2339 */}
      </SidebarModalListItem.Actions>
    </SidebarModalListItem>
  )
}

export default AttachmentListItem
